module.exports = "/_next/static/images/pro-contact-mobile-ca88f79608c2383170ec27f5c9f382e2.svg";